import React from 'react'
import { Link } from 'react-router-dom'
import  DataExplorerSearch  from '../DataExplorerSearch'
import './index.css'

export default class DataExplorerHeader extends React.Component {
  render() {
    return (
      <div className="background-blue-map text-white">
        <div className="w-100 h-100 pa3 background-blue-map-overlay">
        <div className="flex flex-column h-container items-stretch">
          <div className="w-100 pa3">
            <h1 className="f-subheadline headline-head tc text-bold" style={{marginTop: 10, marginBottom:10}}>
              <Link to="/" className="dim no-underline text-white">Explore trade facilitation data</Link>
            </h1>
            <div className="text-white tc mt3">
              <Link className="no-underline underline-hover text-white text-bold" to="/third-pillar">
                Explore the current status of the Trade Facilitation in the World
              </Link>
            </div>
          </div>
        </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataExplorerHeader/index.js